import { Component, Input, OnInit } from '@angular/core';
import { PageContentModel } from 'src/app/models/page-content.model';

@Component({
    selector: 'app-dynamic-tab-list',
    templateUrl: './dynamic-tab-list.component.html',
    styleUrls: ['./dynamic-tab-list.component.scss'],
    standalone: false
})
export class DynamicTabListComponent implements OnInit {

  @Input() pageContent: PageContentModel
  
  activeIndex: number = 0

  constructor() { }

  ngOnInit(): void {
  }

}
